export type Sprachbefehl =
	| { typ: 'rueckgaengig' }
	| { typ: 'naechster_raum' }
	| { typ: 'weiter' }
	| { typ: 'raum_wechseln'; raumName: string };

function normalisiere(text: string): string {
	return text
		.toLowerCase()
		.replace(/[.,!?]/g, '')
		.replace(/\s+/g, ' ')
		.trim();
}

/**
 * Kleine, vollständig lokale Befehlsmenge. Sie bleibt absichtlich streng,
 * damit ein normaler Befund nicht versehentlich als Navigation interpretiert
 * wird und funktioniert auch dann, wenn der KI-Server nicht erreichbar ist.
 */
export function erkenneSprachbefehl(text: string): Sprachbefehl | null {
	const satz = normalisiere(text);

	if (['rückgängig', 'letzten eintrag rückgängig', 'letzten eintrag löschen'].includes(satz)) {
		return { typ: 'rueckgaengig' };
	}
	if (['nächster raum', 'zum nächsten raum', 'weiter zum nächsten raum'].includes(satz)) {
		return { typ: 'naechster_raum' };
	}
	if (['weiter zu den zählern', 'zu den zählern', 'rundgang beenden'].includes(satz)) {
		return { typ: 'weiter' };
	}

	const treffer = satz.match(/^(?:wechsle|wechsel|gehe|geh) (?:zu|zum|in|ins) (.+)$/);
	if (treffer?.[1]) {
		return { typ: 'raum_wechseln', raumName: treffer[1].replace(/^der |^die |^das /, '').trim() };
	}

	return null;
}
